import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Notebook,
  DesignChapterMob,
  EndSimulation,
} from "@learningblocks/storybook-components";
import { Utilities } from "@learningblocks/exp-constants";
const { NOTEBOOK } = Utilities;
import Modal from "react-modal";

const appElement = document.getElementById("container");
if (appElement) {
  Modal.setAppElement("#container");
}

/**
 * Content
 *  - Display contents of the chapter if chapter is selected
 *    display nothing if not current chapter
 */
export function Content(props) {
  const onClickNextSection = () => props.goToNext(props.nextMenuValue);

  const isLastChapter = props.nextMenuValue === undefined;

  const isDesignChapter = props.currentMenu.value === NOTEBOOK.SECTION.DESIGN;

  const [endSimModal, setEndSimModal] = useState(false);

  const openModal = () => {
    setEndSimModal(true);
  };

  const closeModal = () => {
    setEndSimModal(false);
  };

  const footerContent = () => {
    if (isLastChapter) {
      return (
        <>
          <Notebook.EndSimulationBanner className="tb_content_footer">
            <Notebook.EndSimulationBannerText
              className="book_content_footer--text"
              text={props.bannerText}
            />
            <Notebook.EndSimulationButtons className="book_content_footer--btns">
              <Notebook.DownloadReportButton
                className="download-btn"
                onClick={openModal}
              />
            </Notebook.EndSimulationButtons>
          </Notebook.EndSimulationBanner>
          <Modal
            isOpen={endSimModal}
            onRequestClose={closeModal}
            contentLabel="End simulation modal"
            className="Modal"
            overlayClassName="Overlay"
          >
            <EndSimulation closeModal={closeModal} />
          </Modal>
        </>
      );
    } else {
      return (
        <Notebook.ContentFooter className="tb_content_footer">
          <Notebook.NextSectionButton
            className="next-button"
            onClick={onClickNextSection}
          />
        </Notebook.ContentFooter>
      );
    }
  };

  const renderContent = () => {
    if (isDesignChapter) {
      return <DesignChapterMob />;
    } else {
      return (
        <>
          <Notebook.ContentBody className="tb_content_body">
            <Notebook.ContentReadArea className="tb_content_body--read">
              {props.currentMenu.value !== NOTEBOOK.SECTION.DESIGN && (
                <Notebook.ContentTitle
                  className="content_title"
                  title={props.currentMenu.title}
                  number={props.currentMenu.number}
                />
              )}
              <Notebook.ContentComponents
                components={props.components}
                className="content_component"
              />
            </Notebook.ContentReadArea>
          </Notebook.ContentBody>
          {footerContent()}
        </>
      );
    }
  };

  if (props.visible) {
    return (
      <Notebook.ContentBlock className="tb_content">
        {renderContent()}
      </Notebook.ContentBlock>
    );
  } else {
    return null;
  }
}

Content.propTypes = {
  /**
   * Components in current section to be displayed in Notebook
   */
  components: PropTypes.arrayOf(PropTypes.object),
  /**
   * Details of currently active menu in menu list
   */
  currentMenu: PropTypes.shape({
    /**
     * Index of menu
     */
    number: PropTypes.number,
    /**
     * Title of menu
     */
    title: PropTypes.string,
    /**
     * Value of menu
     */
    value: PropTypes.string,
  }),
  /**
   * To hide/display content based on selected Menu
   */
  visible: PropTypes.bool,
  /**
   * Value for next-in-line menu
   * NONE value mens no more next section
   */
  nextMenuValue: PropTypes.oneOf([
    "CONTEXT",
    "TECHNIQUES",
    "DESIGN",
    "PROBLEM_SOLVING",
    "RESULTS",
    "REFLECTION",
    "TROUBLESHOOTING",
    "NONE",
  ]),
  /**
   * Function invoked to go to next section
   */
  goToNext: PropTypes.func,
};

Content.defaultProps = {
  components: [],
  visible: false,
};
